let newsInfo = {
  result: 0,
  desc: "successful",
  content: {
    article: [
      {
        name: "赛诺贝斯全姿子数子子子子赛诺贝斯全姿子数子子子子",
        coverImageRealPath: "./images/noimg.png",
        desc: "激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面",
      },
      {
        name: "赛诺贝斯赛诺贝斯全姿子数子子子子赛诺贝斯全姿子数子子子子",
        coverImageRealPath: "./images/noimg.png",
        desc: "激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面",
      },
      {
        name: "赛诺贝斯赛诺贝斯全姿子数子子子子赛诺贝斯全姿子数子子子子",
        coverImageRealPath: "./images/noimg.png",
        desc: "激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面",
      },
      {
        name: "赛诺贝斯赛诺贝斯全姿子数子子子子赛诺贝斯全姿子数子子子子",
        coverImageRealPath: "./images/noimg.png",
        desc: "激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面",
      },
      {
        name: "赛诺贝斯赛诺贝斯全姿子数子子子子赛诺贝斯全姿子数子子子子",
        coverImageRealPath: "./images/noimg.png",
        desc: "激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面",
      },
      {
        name: "赛诺贝斯赛诺贝斯全姿子数子子子子赛诺贝斯全姿子数子子子子",
        coverImageRealPath: "./images/noimg.png",
        desc: "激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面激励激励全方面",
      },
    ],
    column: [
      {
        name: "黄金伙伴",
        article: [],
      },
    ],
  },
};
export default newsInfo;
